import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { INotification } from '../../_api/notification.api';
import { NotificationItem } from './NotificationItem';

interface INotificationListProps {
    notifications: INotification[];
    onNotificationClick?: (notification: INotification) => void;
    emptyMessage?: string;
}

/**
 * NotificationList Component
 * 
 * Displays a scrollable list of notifications.
 * Follows Single Responsibility Principle - manages the list rendering.
 */
export const NotificationList: React.FC<INotificationListProps> = ({ 
    notifications, 
    onNotificationClick,
    emptyMessage = 'No notifications yet'
}) => {
    if (notifications.length === 0) {
        return (
            <Box 
                sx={{ 
                    py: 8, 
                    px: 3, 
                    textAlign: 'center' 
                }}
            >
                <Typography variant="body2" color="text.secondary">
                    {emptyMessage}
                </Typography>
            </Box>
        );
    }

    return (
        <Box 
            sx={{ 
                maxHeight: 400, 
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                    width: '8px',
                },
                '&::-webkit-scrollbar-track': {
                    backgroundColor: 'transparent',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0,0,0,0.2)',
                    borderRadius: '4px',
                },
            }}
        >
            {notifications.map((notification) => (
                <NotificationItem
                    key={notification.id}
                    notification={notification}
                    onClick={onNotificationClick}
                />
            ))}
        </Box>
    );
};
